import React from 'react';
import { useTranslation } from 'react-i18next';
import ItemMenu from 'components/ItemMenu';
import ItemMenuButton from 'components/ItemMenuButton';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  handleChange: () => void;
  handleDelete: () => void;
}

const SetGroupListItemMenu = ({ isOpen, handleClose, handleChange, handleDelete }: Props) => {
  const { t } = useTranslation('sets');
  return (
    <ItemMenu isOpen={!!isOpen} handleClose={handleClose}>
      <ItemMenuButton label={t('groupsList.setGroupMenu.rename')} icon="icon_background_16.svg" isInPopover handleClick={handleChange} />
      <ItemMenuButton
        label={t('groupsList.setGroupMenu.changePicture')}
        icon="icon_camera-2_16.svg"
        isInPopover
        handleClick={handleChange}
      />
      <ItemMenuButton label={t('groupsList.setGroupMenu.delete')} icon="icon_bin_16.svg" warning isInPopover handleClick={handleDelete} />
    </ItemMenu>
  );
};

export default SetGroupListItemMenu;
